// utils/v3/menuFilter.ts — QR menu-set allowlist (SPEC §6)
// Port of legacy `composables/useQrcodeMenuSetting.ts` (computeGroup + getFullItemsList),
// guest path only (the employee branch is gone in V3).
import type { MenuGroup, Product, ProductAllowMap } from '~/types/v3/entities'

/**
 * Keep a group whole when the group itself is allowed; otherwise keep only its
 * allowed items and drop the group when nothing is left. Groups without an
 * `items` array are skipped (legacy "Fix bug not have items").
 * Returns new group objects; the input is never mutated.
 */
export function filterMenuByAllowlist(
  groups: readonly MenuGroup[] | null | undefined,
  allow: ProductAllowMap | null | undefined
): MenuGroup[] {
  const allowMap = allow ?? {}
  const result: MenuGroup[] = []

  for (const group of groups ?? []) {
    if (!group) continue

    if (allowMap[group.productId]) {
      result.push({ ...group, items: group.items ? [...group.items] : [] })
      continue
    }

    if (group.items === undefined || group.items === null) continue

    const items: Product[] = []
    for (const item of group.items) {
      if (item && allowMap[item.productId]) items.push(item)
    }

    if (items.length >= 1) result.push({ ...group, items })
  }

  return result
}

/** Flat list of every item of the given (already filtered) groups — used for search. */
export function flattenItems(groups: readonly MenuGroup[] | null | undefined): Product[] {
  const result: Product[] = []
  for (const group of groups ?? []) {
    if (group?.items) result.push(...group.items)
  }
  return result
}
